module.exports = __webpack_public_path__ + "img/4.27ef4a6f.png";